module.exports = __webpack_public_path__ + "img/green_mtn.385a49de.jpg";